import { BundleModifyTypes, PurchaseTypes } from "../app/shared/types/flows-config.types";
import { BundleEditionTypes } from "../app/shared/types/order.type";

const base_api = "https://carltonfarms-back-dev.navego.tech";

export const environment = {
  production: false,
  apis: {
    v1: `${base_api}`,
    v2: `${base_api}/api/v2`,
    v3: `${base_api}/api/v3`,
    google: {
      places: 'AIzaSyBTHTviZ7QPtEjH29Jmmkp13RO8LPrxppM'
    },
    navego: {
      url: 'https://apis.navego.tech/api',
      key: 'dsfgrdf125fdffasd677rrfgr',
      clientNr: '25'
    },
    firebase: {
      apiKey: "AIzaSyD-zHHVvmSvmnOOwawX2bJ_yx0RwriV5Co",
      authDomain: "dev-carlton-farms.firebaseapp.com",
      projectId: "dev-carlton-farms",
      storageBucket: "dev-carlton-farms.firebasestorage.app",
      messagingSenderId: "669925125085",
      appId: "1:669925125085:web:e13da0ba373ce918b32434",
      measurementId: "G-0H4WF661CT"
    },
    klaviyo: {
      publicApiKey: ''
    },
    maintenance: {
      url: 'https://ecommerce-configurations.navego.tech/api/v3/maintenance?url=carltonfarms-dev'
    },
    authorize: {
      APILoginID: '859vpT8YqF',
      PublicClientkey: '2789LLpawLnj4TJe2s5k7akamxnXS3aTq442sEs4vkU82JnTQ56e93fNuMUXmfC6'
    }
  },
  application: {
    angular: 'Angular 19.2.6',
    bootstrap: 'Bootstrap 5.3.2',
    fontawesome: 'Font Awesome 6.5.1',
    name: 'Carlton Farms',
    version: '1.0.0',
  },
  config: {
    bodyClass: 'app-me',
    crypto: {
      key: '',
    },
    flows: {
      territories: false,
      membership: false,
      settings: {
        toHide: {
          membership: 'Membership'
        },
        profile: {
          hasPickupLocationsFlow: true
        },
        deliveryDayUpdates: {
          displayOnlyActiveReescheduledOrder: true
        }
      },
      specialMembership: {
        defaultRoute: '/order/custom-box/' + BundleEditionTypes.subscription,
        settings: {
          hideHeaderCategoriesNav: true
        },
      },
      order: {
        askForDonationOnSkip: false,
        showFreeDeliverySlider: true,
        voluntaryDonationFlow: false,
        showProductStatusTag: false,
        hasDriveTipsFlow: false,
      },
      bundles: {
        modifyType: BundleModifyTypes.outOfOrder,
      },
      shop: {
        validateMarketState: true
      },
      login: {
        tempResetPassword: true
      },
      purchase: {
        type: PurchaseTypes.anet
      },
      welcomePage: {
        categoryToFetch: 10
      },
    },
    filesVersionNumber: {
      logo: 2
    },
    friendReferral: {
      baseUrl: 'https://carltonfarms.com/signup?utm_source=friend_referral&utm_medium=share&utm_campaign='
    },
    seo: {
      mainTitle: 'Carlton Farm | Local, Sustainable Meats and Produce',
      mainDescription: 'Carlton Farms is a diversified sustainable family farm located 45 miles NW of Atlanta. We produce raw cows milk for pets, free range eggs, grass fed beef and lamb,as well as pasture raised poultry and pork. In addition to our products, we also carry other naturally produced foods from our friends in the local natural farming community. These items include fruits and vegetables, local raw honey, organic pecans, and others.',
      baseTitle: 'Naturally Raised Meats & Dairy from Our Family Farm',
      baseKeywords: ['raw cow milk', 'free-range eggs', 'grass-fed beef', 'grass-fed lamb', 'pasture raised poultry', 'pasture raised pork', 'Weston A. Price', 'A1', 'A2', 'Sally Fallon', 'Paleo', 'Atlanta', 'Georgia', 'GA', 'Home delivery', 'local', 'farm', 'organic', 'sustainable', 'bone broth'],
      type: 'website',
      baseURL: 'https://carltonfarm.com'
    },
    contactEmail: 'info@carltonfarm.com'
  },
};
